export default {
  progress: '{0} of {1}',
};
